import { useCallback } from 'react';
import useAxiosInstance from './axiosInstance';

/**
 * Custom hook to preview files from the server.
 * @param {function} navigate - Function to navigate to another page.
 * @returns {object} Object containing the previewFile function.
 */
const useFilePreview = (navigate, container_name=null) => {
  const axiosInstance = useAxiosInstance(navigate);

  const previewFile = useCallback(async (fileName) => {
    try {
      const response = await axiosInstance.post(container_name ? `/files/sas?container=${container_name}` : '/files/sas', {
        fileName, // Pass the file name in the request body
      });
      return response.data;
    } catch (error) {
      console.error(`Error previewing file: ${fileName}`, error);
      throw error;
    }
  }, [axiosInstance, container_name]);

  return { previewFile };
};

export default useFilePreview;